import useToast from '@/hooks/useToast';
import api from '@/services/api/v2';
import { useEffect } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';

export interface INotification {
  id: number; // 알림 고유 id
  userId: number; // 수신자 사용자 id
  title: string; // 알림 제목
  body: string; // 알림 내용
  category: 'NONE' | 'INQUIRY' | 'TASK'; // 알림 카테고리. '없음', '문의', '업무'
  isRead: boolean; // 읽음 여부
  readAt: string | null; // 읽은 시각. ISO8601형식. "2025-08-12T16:04:45.969855" 읽지 않은 경우 null
  createdAt: string; // 생성 시각. "2025-08-12T16:04:45.969855"
  payload: any;
}

type Dto = {
  notifications: {
    content: INotification[];
    empty: boolean;
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
  };
  stats: {
    read: number;
    total: number;
    unread: number;
  };
};

export const useAlarmcenter = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const {
    data: stats,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['alarmcenter', 'list'],
    async queryFn() {
      try {
        const res = await api.get<Dto>(`/spation/notifications`);
        return res?.data?.stats;
      } catch (error) {
        console.error(error);
        return { read: 0, total: 0, unread: 0 };
      }
    },
    refetchOnWindowFocus: true,
    suspense: false,
  });

  const { mutate: readNotification } = useMutation({
    mutationFn: async (id: number) => {
      await api.patch(`/spation/notifications/${id}/read`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['alarmcenter', 'list']);
      queryClient.invalidateQueries(['alarmcenter', 'page']);
    },
  });

  const { mutate: readAllNotifications } = useMutation({
    mutationFn: async () => {
      await api.patch(`/spation/notifications/read`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['alarmcenter', 'list']);
      queryClient.invalidateQueries(['alarmcenter', 'page']);
    },
  });

  useEffect(() => {
    if (isError) {
      toast.error('알림 내역을 불러오는데 실패했습니다.');
    }
  }, [isError]);
  return {
    stats,
    isLoading,
    readNotification,
    readAllNotifications,
  };
};
